import type { PictureInferenceFilterOptionGroup } from 'horizon/routes/Inspections/InspectionDetail/pictureInferenceFilter.utils';

import type { ImageProps } from '../Image';

import { AssetOverlayTool } from './AssetOverlayTool';
import {
  ButtonContainer,
  ControlsContainer,
  ThumbnailButtonContainer,
  ThumbnailControlsContainer,
} from './Controls.style';
import { Filters } from './Filters';
import { InferenceFilterTool } from './InferenceFilterTool';
import { Measurement } from './Measurement';
import { Rotate } from './Rotate';
import { Temperature } from './Temperature';
import { Zoom } from './Zoom';

type ControlsProps = {
  onChange: (arg: any) => void;
  onClickLevels: () => void;
  value?: {
    rotate?: boolean;
    filter?: string;
    levels?: { url?: string; width?: number; height?: number; a?: number; b?: number };
    measure?: boolean;
    temperature?: boolean;
    edit?: boolean;
    assetOverlay?: boolean;
    selectedInferenceDetectionTypeIds?: string[];
    selectedInferenceDeltaTMin?: number;
  };
  isThumbnail?: boolean;
  pictureId?: string;
  pictureGlobalId?: string;
  refetch: ImageProps['refetch'];
  hasHomography?: boolean;
  inferenceFilterOptions?: PictureInferenceFilterOptionGroup[];
  rotationEnabled?: boolean;
  hasImageViewerEnhancementsReleaseToggle?: boolean;
};

export const Controls = ({
  onChange,
  onClickLevels,
  value,
  isThumbnail = false,
  pictureId,
  pictureGlobalId,
  refetch,
  hasHomography = false,
  inferenceFilterOptions = [],
  rotationEnabled,
  hasImageViewerEnhancementsReleaseToggle = false,
}: ControlsProps) => {
  const {
    rotate,
    filter,
    levels,
    measure,
    temperature,
    assetOverlay,
    selectedInferenceDetectionTypeIds,
    selectedInferenceDeltaTMin,
    edit,
  } = value ?? {};

  if (isThumbnail) {
    return (
      <ThumbnailControlsContainer>
        <ThumbnailButtonContainer>
          <Zoom onChange={onChange} />
        </ThumbnailButtonContainer>
        <ThumbnailButtonContainer>
          <Rotate onChange={onChange} value={rotate} disabled={!rotationEnabled} />
        </ThumbnailButtonContainer>
      </ThumbnailControlsContainer>
    );
  }

  return (
    <ControlsContainer>
      {assetOverlay !== undefined && (
        <ButtonContainer>
          <AssetOverlayTool onChange={onChange} value={assetOverlay} disabled={edit} />
        </ButtonContainer>
      )}
      {selectedInferenceDetectionTypeIds !== undefined && (
        <ButtonContainer>
          <InferenceFilterTool
            onChange={onChange}
            value={selectedInferenceDetectionTypeIds}
            selectedInferenceDeltaTMin={selectedInferenceDeltaTMin}
            options={inferenceFilterOptions}
            disabled={Boolean(edit)}
          />
        </ButtonContainer>
      )}
      {temperature !== undefined && (
        <ButtonContainer>
          <Temperature onChange={onChange} value={temperature} disabled={edit} />
        </ButtonContainer>
      )}
      {measure !== undefined && (
        <ButtonContainer>
          <Measurement
            onChange={onChange}
            value={measure}
            disabled={edit}
            hasHomography={hasHomography}
          />
        </ButtonContainer>
      )}
      <ButtonContainer>
        <Rotate onChange={onChange} value={rotate} disabled={!rotationEnabled} />
      </ButtonContainer>
      <ButtonContainer>
        <Filters
          onChange={onChange}
          onClickLevels={onClickLevels}
          value={filter}
          levels={levels}
          pictureId={pictureId}
          pictureGlobalId={pictureGlobalId}
          refetch={refetch}
        />
      </ButtonContainer>
      <ButtonContainer $zoomControl={hasImageViewerEnhancementsReleaseToggle}>
        <Zoom onChange={onChange} />
      </ButtonContainer>
    </ControlsContainer>
  );
};
